import { useEffect } from "react";
import useFetch from "./useFetch";
import useAlertContext from "Hooks/useAlertContext";

/**  Checks the agent status and displays an alert if the agent is offline
 * @returns Nothing
 * @see AlertContextProvider.tsx
 * @example useAgentStatus();
 */
export default function useAgentStatus() {
    const { newAlert } = useAlertContext();
    const { get } = useFetch();

    // Get the agent status
    useEffect(() => {
        let ignore = false;

        if (ignore) return;
        (async () => {
            const response = await get(`/api/agent_status`);
            if (!ignore && response.ok) {
                const data = await response.json();
                console.log("Is agent online: ", data);

                if (data === false) {
                    newAlert({
                        color: "danger",
                        message: "Agent is offline!",
                        seconds: 60 * 30,
                    });
                }
            }
        })();

        return () => {
            ignore = true;
        };
    }, [get, newAlert]);
}
